$(document).ready(function () {
    var status;

    $('#skicka-kommentar').prop('disabled', true);

    $('[name*="EpostModel"]').keyup(function () {
        var name = $('#Layout_EpostModel_Namn').val().trim().length;
        var meddelande = $('#Layout_EpostModel_Meddelande').val().trim().length;

        if (!isValidEmailAddress($('#Layout_EpostModel_Epost').val()) || name === 0 || meddelande === 0) {
            $('#skicka-kommentar').prop('disabled', true);
        } else {
            $('#skicka-kommentar').prop('disabled', false);
        }
    });

    $('.ggi-hand-v, .ggi-hand-h').click(function () {
        $('div.ggi-steg2').show();
        $('input#Layout_EpostModel_Namn').focus();

        if ($(this).text().toLowerCase() === 'ja') {
            status = 'Gilla';
        } else {
            status = 'Gilla inte';
        }
    });

    $('#skicka-kommentar').click(function () {
        var validator = $('.gillagillainte form').validate();
        $('div.ggi-steg2').addClass('dynamisktinnehall-laddar');

        if (validator.valid()) {
            var epostMeddelande = {
                namn: $('input#Layout_EpostModel_Namn').val(),
                epost: $('input#Layout_EpostModel_Epost').val(),
                amne: status,
                meddelande: $('textarea#Layout_EpostModel_Meddelande').val(),
                contentLink: $('#Layout_EpostModel_ContentLink').val()
            };

            $.ajax({
                type: 'POST',
                url: '/webapi/epost',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(epostMeddelande),
                dataType: 'json',
                success: function () {
                    $('div.ggi-steg1, div.ggi-steg2').hide();
                    $('div.ggi-steg3').show();

                    saveGillaGillaInte();
                },
                complete: function () {
                    $('div.ggi-steg2').removeClass('dynamisktinnehall-laddar');
                },
                error: function (jqXHR) {
                    var data = JSON.parse(jqXHR.responseText);
                    var errors = {};

                    for (var key in data.ModelState) {
                        if (Object.prototype.hasOwnProperty.call(data.ModelState, key)) {
                            errors[key.replace('model.', '')] = data.ModelState[key][0];
                        }
                    }

                    validator.showErrors(errors);
                    validator.focusInvalid();
                }
            });
        } else {
            validator.focusInvalid();
        }
    });

    function isValidEmailAddress(emailAddress) {
        var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,6}$/i;

        return pattern.test(emailAddress);
    }

    function saveGillaGillaInte() {
        var message = $('textarea#Layout_EpostModel_Meddelande').val();
        var link = window.location.href;
        var datetime = addHours(2);
        var internalId = createGuid();

        var gillaGillaInteModel = {
            message: message,
            link: link,
            date: datetime,
            internalId: internalId,
            hand: status
        };

        return $.ajax({
            type: 'POST',
            url: '/webapi/gillagillainte/save',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(gillaGillaInteModel),
            dataType: 'json',
            success: function () {
            },
            error: function () {
            }
        });
    }

    function createGuid() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    function addHours(h) {
        return new Date(new Date().getTime() + (h * 1000 * 60 * 60));
    }
});
